import React from "react";
import { scoreTier, scoreLabel } from "@/lib/mockData";

const STYLES = {
  genuine: "bg-emerald-500/10 text-emerald-400 border-emerald-500/25",
  inconclusive: "bg-amber-500/10 text-amber-400 border-amber-500/25",
  ai: "bg-red-500/10 text-red-400 border-red-500/25",
};

export function ScoreDot({ score }) {
  const tier = scoreTier(score);
  const color =
    tier === "genuine" ? "bg-emerald-500" : tier === "inconclusive" ? "bg-amber-500" : "bg-red-500";
  return <span className={`inline-block h-2 w-2 rounded-full ${color}`} aria-hidden="true" />;
}

export default function ScoreBadge({ score, withLabel = true, className = "" }) {
  const tier = scoreTier(score);
  return (
    <span
      data-testid={`score-badge-${tier}`}
      className={`inline-flex items-center gap-2 rounded-full border px-2.5 py-0.5 text-xs font-medium ${STYLES[tier]} ${className}`}
    >
      <ScoreDot score={score} />
      <span className="tabular-nums">{score}</span>
      {withLabel && <span className="text-[11px] opacity-80">{scoreLabel(score)}</span>}
    </span>
  );
}
